import { type NuxtAxiosInstance } from "@nuxtjs/axios";

import { useApi } from "@/utils/api";

export default function useCreatorShopSearchApi($axios: NuxtAxiosInstance) {
  const baseUrl = "/v1/creator-shop";
  const _api = useApi({ name: "consumerSearchService", url: baseUrl, $axios });

  async function fetchCreatorShopSearchPostResults(profileId: string, data: PostCreatorShopSearchRequest) {
    return await _api.request<PostCreatorShopSearchPostIDResponse>({
      url: `${baseUrl}/profiles/${profileId}/search/ids`,
      method: "POST",
      data,
    });
  }

  async function fetchCreatorShopSearchProductResults(
    profileId: string,
    data: Omit<PostCreatorShopSearchRequest, "types">,
  ) {
    return await _api.request<PostCreatorShopSearchProductIDResponse>({
      url: `${baseUrl}/profiles/${profileId}/search/ids`,
      method: "POST",
      data: {
        ...data,
        types: ["product"],
      },
    });
  }

  return { fetchCreatorShopSearchPostResults, fetchCreatorShopSearchProductResults };
}
